import { FC, useState } from "react";
import './sellerBanner.css'
import { ModalInfoSeller } from "../ModalInfoSeller/modalInfoSeller";
import { useSellerInfo } from "../../contexts/sellerInfoContext";

type Props = {
  marginTop?: string
  marginBottom?: string
}

const SellerBanner: FC<Props> = (Props) => {

  const { sellerInfo } = useSellerInfo();
  const { marginTop, marginBottom } = Props
  const [openInfo, setOpenInfo] = useState(false);


  return (
    <>
      {sellerInfo.id ? (
        <div className="banner" style={{
          marginTop: marginTop ? marginTop : '',
          marginBottom: marginBottom ? marginBottom : '',
        }} onClick={() => setOpenInfo(true)}>
          <div className="banner-body">
            {sellerInfo.image && sellerInfo.image != 'default/default-user.jpg' &&
              <div className="banner-seller-info-img">
                <img src={sellerInfo.image} alt="" />
              </div>
            }
            <div className="banner-seller-info" style={{
              paddingLeft: `${!(sellerInfo.image && sellerInfo.image != 'default/default-user.jpg') ? '4px' : '0px'}`
            }}>
              <span>Você está comprando com: </span>
              <span className="link">{sellerInfo.name}</span>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )



      }
      {openInfo && (
        <ModalInfoSeller isOpen={openInfo} setIsOpen={setOpenInfo} />
      )}
    </>
  )
}


export { SellerBanner }